export const appSettingsAppGroupIdMessagePrioritizationFrequencyCappingCoverage =
  "/app_settings/:app_group_id/message_prioritization/frequency_capping_coverage";
